import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { canManagePerformance, getUserRoles } from '../utils/roleHelpers';

const PerformanceConfigRoute = ({ children }) => {
  const { user } = useAuth();
  if (canManagePerformance(user)) return children;
  const roles = getUserRoles(user);
  const canConsult = roles.includes('secretary') || roles.includes('teacher');
  return <Navigate to={canConsult ? '/performance/results' : '/'} replace />;
};

export default PerformanceConfigRoute;
